// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_-exX5","pure-video":"pure-video_fBMpf","control-btn":"control-btn_0bih7","control-btn-hide":"control-btn-hide_O9Hs-"};